/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {Component, useEffect, useState} from 'react';
import BreadCrumb from '../../common/components/BreadCrumb';
import {Row, Col, Button, Form} from 'react-bootstrap';

import TextHoverDisplay from "../../common/components/TextHoverDisplay";

import './AdminActionListContainer.scss';

import {
    getAdminListById,
    downloadList
} from "./adminListSlice";


import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import {APP_COLORS} from "../../common/Constants";

const AdminDownloadListContainer = (props) => {
    const { id } = useParams();
    const adminListState = useSelector(state => state.adminList);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [downloadResult, setDownloadResult] = useState(null);

    const [breadcrumbItems, setBreadcrumbItems] = useState([]);

    const [managedList, setManagedList] = useState(null);

    useEffect(() => {
        dispatch(getAdminListById(id));

    }, [id, dispatch]);

    useEffect(() => {
        if (adminListState.adminList && adminListState.adminList.id === id) {
            setManagedList(adminListState.adminList);
            setBreadcrumbItems(
                [
                    {label: 'Home', href: '/home', isActive: false},
                    {
                        label: 'Lists',
                        href: '/admin/lists',
                        isActive: false
                    },
                    {
                        label: `${id}`,
                        href: '',
                        isActive: true
                    },
                    {
                        label: 'Download List',
                        href: '',
                        isActive: true
                    }
                 ]
            )
        }
        }
        , [adminListState.adminList]);

    useEffect(() => {
        setAlertMessage(adminListState.alertMessage);
        if (adminListState.alertMessage) {
            setShowAlert(true);
        } else {
            setShowAlert(false);
        }
    }, [adminListState.alertMessage]);

    useEffect(() => {
        setSuccessMessage(adminListState.successMessage);
        if (!adminListState.successMessage) {
            setShowSuccess(false);
        }
    }, [adminListState.successMessage]);

    useEffect(() => {
        setDownloadResult(adminListState.download);
    }, [adminListState.download]);

    const handleDownload = async (data) => {
        dispatch(downloadList(data));
    };

    const handleCancel = async () => {
        navigate('/admin/lists')
    };

    return (
        <div>
            {adminListState.loading && (
                <div className="spinner-overlay">
                    <Spinner
                        as="span"
                        animation="border"
                        size="lg"
                        role="status"
                        aria-hidden="true"
                        variant="info"
                    />
                </div>
            )}
            <Alert
                variant={"danger"}
                show={showAlert}
                onClose={() => setShowAlert(!showAlert)}
                dismissible
                transition={false}
            >
                {alertMessage}
            </Alert>
            <Alert
                variant={"success"}
                show={showSuccess}
                onClose={() => setShowSuccess(!showSuccess)}
                dismissible
                transition={false}
            >
                {successMessage}
            </Alert>
            <AdminDownloadList
                id={managedList?.id}
                name={managedList?.name}
                handleAdminDownload={(data) => handleDownload(data)}
                handleCancel={() => handleCancel()}
                status={managedList?.status}
                type={managedList?.type}
                breadcrumbItems={breadcrumbItems}
                downloadResult={downloadResult}
            />

        </div>
    );
};


function AdminDownloadList(props) {

    const {
        breadcrumbItems,
        id,
        name,
        status,
        type,
        handleAdminDownload,
        handleCancel,
        downloadResult,
    } = props;
    const reset = () => {

    };

    const isValid = () => {
        if (status === 'CREATED' ||
            status === 'PARSING'
        ) {
            return false;
        }
        return true;
    };

    const handleDownloadClick = async () => {
        handleAdminDownload({id: id, fileName: name});
    };

    const formatBytes = (bytes, decimals = 2) => {
        if (!+bytes) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    };

    return (
        <div className="action-list-gutter">
            <BreadCrumb items={breadcrumbItems}> </BreadCrumb>
            <div className="panel" style={{backgroundColor: APP_COLORS['gray-100']}}>
                <Row style={{alignItems: "baseline"}}>
                    <Col xl={12} lg={12} md={12} sm={12} style={{alignItems: "baseline"}}>
                        <div className="action-list-header"><h2>{`Download List - ${name ? name : ''}`}</h2></div>
                    </Col>
                </Row>
                <Row>
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <div className="sectionHorizontalDivider"/>
                    </Col>
                </Row>
                <Row style={{alignItems: "baseline"}}>
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <div className="action-list-header"><small
                            className="header">Download the list</small></div>
                    </Col>
                </Row>
            </div>
            <div className="action-list-container">
                <div className="action-list-form-container">
                    <Form noValidate>
                        <Form.Group controlId="downloadList">
                            <Row>
                                <Col md={6}>
                                    <Row>
                                        <Col md={9} className="action-list-form-label">
                                            <Form.Label>List Id</Form.Label>
                                            {id &&
                                                <TextHoverDisplay
                                                    fullText={id}
                                                    truncatedText={id}
                                                    displayTruncated={false}
                                                />
                                            }

                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={9} className="create-input-form-label">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                as="input"
                                                size="sm"
                                                disabled
                                                value={name}
                                            />
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col md={9} className="create-input-form-label">
                                            <Form.Label>Type</Form.Label>
                                            <Form.Control
                                                as="input"
                                                size="sm"
                                                disabled
                                                value={type}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={9} className="create-input-form-label">
                                            <Form.Label>File Name</Form.Label>
                                            <Form.Control
                                                as="input"
                                                size="sm"
                                                disabled
                                                value={name ? `${name}.csv` : ''}
                                            />
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>
                            <Row>
                                <Col xl={12} lg={12} md={12} sm={12} className="buttons">
                                    <Button
                                        className="btn-min-width-120 btn-height-35"
                                        variant="info"
                                        disabled={!isValid()}
                                        onClick={() => handleDownloadClick()}
                                    >Download
                                    </Button>
                                    <Button
                                        className="btn-min-width-120 btn-height-35"
                                        style={{marginLeft: "10px"}}
                                        variant="outline-secondary"
                                        onClick={() => {
                                            reset();
                                            handleCancel();
                                        }}
                                    >CANCEL
                                    </Button>
                                </Col>
                            </Row>
                        </Form.Group>
                    </Form>
                </div>
            </div>
            {downloadResult &&
            <div className="action-list-container">
                <div>Your download is ready. Click the link below to download.</div>
                <div>
                    <a href={`${downloadResult.dataUrl}`}
                       download>
                                            <span style={{fontStyle: 'italic', textDecoration: 'underline'}}>
                                            {`${name}.csv`}
                                            </span>
                    </a>
                </div>
                <div>
                    <div>Status:</div>
                    <div>{`Records: ${downloadResult.dataCntRecords}`}</div>
                    <div>{`Size: ${formatBytes(downloadResult.dataSizeBytes)}`}</div>
                    <div>{`Ref: ${downloadResult.dataRef}`}</div>
                </div>
            </div>
            }
        </div>
    );
}

export default AdminDownloadListContainer;

